(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-choice-button/assets/javascripts/coupon-choice-button.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-choice-button/assets/javascripts/coupon-choice-button.js');
"use strict";

const {
  ReactButton,
  ReactIcon
} = svs.ui;
const {
  clx
} = svs.components.lbUtils;
const {
  analytics
} = svs.components;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_AM
} = svs.components.lbUtils.useMediaQuery;
const {
  useBranding
} = svs.components.tipsen.hooks;
const {
  useCurrentDraw
} = svs.components.tipsen.drawProvider.hooks;
const {
  getProductBrandByDraw
} = svs.components.lbUtils.brandMapping.fn;
const CouponChoiceButton = _ref => {
  let {
    ariaControls,
    isAriaExpanded,
    ariaLabel,
    children,
    className,
    'data-testid': dataTestId,
    hasClickAnalytics = true,
    icon,
    isDisabled,
    isSelected,
    onClick
  } = _ref;
  const isSmall = useMediaQuery(breakpoints.down(BREAKPOINT_AM));
  const buttonAndIconSize = isSmall ? 200 : 300;
  const draw = useCurrentDraw();
  const brandingList = useBranding();
  const brandingByDraw = getProductBrandByDraw(draw);
  const branding = brandingByDraw || brandingList[brandingList.length - 1] || brandingList[0] || 'sport';
  const blockName = 'btn-coupon-choice';
  const classNames = clx(blockName, className, {
    ["".concat(blockName, "-selected")]: isSelected,
    ["".concat(blockName, "-disabled")]: isDisabled,
    ["".concat(blockName, "-branding-").concat(branding)]: branding
  });
  const trackEventOnCouponChoiceButton = () => {
    analytics.trackEvent({
      category: "Nya tipsen",
      action: children,
      opt_label: location.pathname
    });
  };
  return React.createElement(ReactButton, {
    "aria-controls": ariaControls,
    "aria-expanded": isAriaExpanded,
    "aria-label": ariaLabel,
    className: classNames,
    "data-testid": dataTestId,
    disabled: isDisabled,
    "icon-position": "left",
    onClick: e => {
      if (hasClickAnalytics) {
        trackEventOnCouponChoiceButton();
      }
      onClick && onClick(e);
    },
    size: buttonAndIconSize,
    title: ariaLabel
  }, icon && React.createElement(ReactIcon, {
    icon: icon,
    size: buttonAndIconSize
  }), children && React.createElement("span", {
    className: "".concat(icon ? 'btn-text' : '')
  }, children));
};
setGlobal('svs.components.tipsen.couponChoiceButton.CouponChoiceButton', CouponChoiceButton);

 })(window);